import React from "react";

// Renders the parsed price sheets exactly as the backend returns them
// ({ title, type, data: string[][] }): 1-cell rows are section headings,
// empty rows are spacing, the first multi-cell row is the column header,
// everything after it is price rows. Shared by the list-page preview and
// the create/edit form's live link preview.
export type BhavSheet = { title: string; type: string; data: string[][] };

const BhavSheetsPreview: React.FC<{ sheets: BhavSheet[]; compact?: boolean }> = ({ sheets, compact }) => {
    if (!sheets?.length) return null;

    return (
        <div className="flex flex-col gap-4">
            {sheets.map((sheet, sheetIndex) => {
                const rows = (sheet.data || []).filter((row) => row.length > 0);
                const headerIdx = rows.findIndex((row) => row.length > 1);
                const headingRows = headerIdx === -1 ? rows : rows.slice(0, headerIdx);
                const headerRow = headerIdx === -1 ? null : rows[headerIdx];
                const bodyRows = headerIdx === -1 ? [] : rows.slice(headerIdx + 1);
                const cellPad = compact ? "4px 8px" : "8px 12px";
                const fontSize = compact ? "12px" : "14px";

                return (
                    <div key={sheetIndex}>
                        {!compact && (
                            <h4 className="m-0 mb-2 font-semibold" style={{ color: "#264164" }}>{sheet.title}</h4>
                        )}
                        {headingRows.map((row, i) => (
                            <p key={i} className="m-0 mb-1 font-semibold" style={{ fontSize, color: "#374151" }}>{row[0]}</p>
                        ))}
                        <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", fontSize }}>
                                {headerRow && (
                                    <thead>
                                        <tr style={{ background: "#264164", color: "#fff" }}>
                                            {headerRow.map((cell, i) => (
                                                <th key={i} style={{ padding: cellPad, border: "1px solid #e5e7eb", textAlign: "left", whiteSpace: "nowrap" }}>{cell}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                )}
                                <tbody>
                                    {bodyRows.map((row, i) => (
                                        <tr key={i} style={{ background: i % 2 === 0 ? "#f9fafb" : "#fff" }}>
                                            {row.map((cell, j) => (
                                                <td key={j} style={{ padding: cellPad, border: "1px solid #e5e7eb" }}>{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default BhavSheetsPreview;
